import JobCreateFormTwoForPractitioner from "./JobCreateFormTwoForPractitioner";
import JobCreateFormTwoForAdmin from "./JobCreateFormTwoForAdmin";
import { isPractitioner } from "utils/UserHelper";

const JobCreateFormTwo = () => {
    if (isPractitioner())
        return <JobCreateFormTwoForPractitioner />
    else
        return <JobCreateFormTwoForAdmin />
}

export default JobCreateFormTwo;